import type { OnboardingStepKey } from '../../config/onboardingRegistry'
import { isOfferMgmtHubStep } from './onboardingOfferManagementGating'

export type GuidedHydrationAction =
  | { type: 'noop' }
  | { type: 'start'; stepKey: OnboardingStepKey | undefined }
  | { type: 'ensure'; stepKey: OnboardingStepKey }

/**
 * Single policy for syncing guided session from URL.
 * - Inactive → start (fresh entry / F5 revive)
 * - Active, same step → ensure (preserve hubOfferIds on OM→module handoff)
 * - Active, different step → start (checklist advanced to next module)
 */
export function resolveGuidedHydrationAction(input: {
  storeActive: boolean
  storeStep: OnboardingStepKey | null
  stepFromUrl: OnboardingStepKey | null
}): GuidedHydrationAction {
  const { storeActive, storeStep, stepFromUrl } = input

  if (!storeActive) {
    return { type: 'start', stepKey: stepFromUrl ?? undefined }
  }

  if (stepFromUrl && storeStep !== stepFromUrl) {
    return { type: 'start', stepKey: stepFromUrl }
  }

  if (stepFromUrl) {
    return { type: 'ensure', stepKey: stepFromUrl }
  }

  return { type: 'noop' }
}

const OFFER_MANAGEMENT_PATH = '/allegro/offer-management'

/**
 * Mid-journey OM entry without ?onboarding=guided (sidebar / bookmark after connect).
 * Starts the next hub step so banner + 2-offer cap match dashboard CTA behavior.
 */
export function resolveJourneyOmEntryAction(input: {
  pathname: string
  storeActive: boolean
  journeyActive: boolean
  nextHubStep: OnboardingStepKey | null
}): GuidedHydrationAction {
  const { pathname, storeActive, journeyActive, nextHubStep } = input

  if (storeActive || !journeyActive) return { type: 'noop' }
  if (pathname !== OFFER_MANAGEMENT_PATH) return { type: 'noop' }
  if (!nextHubStep || !isOfferMgmtHubStep(nextHubStep)) return { type: 'noop' }

  return { type: 'start', stepKey: nextHubStep }
}
